'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuGroup", {
    enumerable: true,
    get: function() {
        return MenuGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuGroup = require("./useMenuGroup");
const _renderMenuGroup = require("./renderMenuGroup");
const _useMenuGroupContextValues = require("./useMenuGroupContextValues");
const _useMenuGroupStylesstyles = require("./useMenuGroupStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuGroup.useMenuGroup_unstable)(props, ref);
    const contextValues = (0, _useMenuGroupContextValues.useMenuGroupContextValues_unstable)(state);
    (0, _useMenuGroupStylesstyles.useMenuGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuGroupStyles_unstable')(state);
    return (0, _renderMenuGroup.renderMenuGroup_unstable)(state, contextValues);
});
MenuGroup.displayName = 'MenuGroup';
